import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Penalty: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={33}>Взыскание</Typography>
                    <Typography mb={1} ml={37}>Дата взыскания</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={14.6}>Дата взыскания</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }} 
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={10.4}>Взыскание</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, ml: 8.9, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={7.8}>Причина взыскания</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, ml: 2.8, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={5.4}>Количество дней прогула</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={14.8}>Номер приказа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={12.1}>Параграф приказа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={16.8}>Дата приказа</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default Penalty;

